import { BookOpen, PlayCircle, Rocket, VideoIcon } from "lucide-react";

export const QuickNav = () => (
  <div className="grid grid-cols-2 gap-3">
    <div className="bg-blue-600 text-white flex flex-col justify-between h-24 rounded-xl p-3 font-semibold text-base">
      <PlayCircle className="w-6 h-6" />
      <span>Home</span>
    </div>
    <div className="bg-red-500 text-white flex flex-col justify-between h-24 rounded-xl p-3 font-semibold text-base">
      <VideoIcon className="w-6 h-6" />
      <span>Live</span>
    </div>
    <div className="bg-purple-500 text-white flex flex-col justify-between h-24 rounded-xl p-3 font-semibold text-base">
      <Rocket className="w-6 h-6" />
      <span>Explore</span>
    </div>
    <div className="bg-teal-500 text-white flex flex-col justify-between h-24 rounded-xl p-3 font-semibold text-base">
      <BookOpen className="w-6 h-6" />
      <span>Shows</span>
    </div>
  </div>
);


export default QuickNav;
